// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"10":"23c50bb5","62":"f7bb1d1a","126":"cfe31095","155":"a11c05a6","157":"5f81aaea","424":"b50affb8","441":"db589b7f","505":"930cf649","520":"13fef804","543":"97da48b0","555":"c3dd9700","718":"86e40e7b","735":"e54e20cd","805":"2489c486","978":"226d41d7"}[chunkId] + ".js";
};